import React from 'react';
import { HelpCircle, MessageSquare, Mail, Phone, Send, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Separator } from '../ui/separator';

const VendorSupportTab = ({
  supportSubject,
  setSupportSubject,
  supportMessage,
  setSupportMessage,
  sendingSupport,
  handleSendSupport
}) => {
  return (
    <div className="bg-gray-50 dark:bg-[#252525] p-6 rounded-xl space-y-4">
      <h3 className="text-lg font-bold text-[#252525] dark:text-white flex items-center gap-2">
        <HelpCircle className="w-5 h-5 text-[#FFD12D]" />
        Contact Support
      </h3>
      
      <p className="text-gray-600 dark:text-gray-400">
        Need help? Send us a message and we'll get back to you as soon as possible.
      </p>

      <div className="space-y-4">
        <div className="space-y-2">
          <Label className="text-[#252525] dark:text-white flex items-center gap-2">
            <MessageSquare className="w-4 h-4 text-[#FFD12D]" />
            Subject <span className="text-red-500">*</span>
          </Label>
          <Input
            value={supportSubject}
            onChange={(e) => setSupportSubject(e.target.value)}
            placeholder="e.g., Help with my stall listing"
            className="dark:bg-[#1a1a1a] dark:text-white"
          />
        </div>

        <div className="space-y-2">
          <Label className="text-[#252525] dark:text-white flex items-center gap-2">
            <Mail className="w-4 h-4 text-[#FFD12D]" />
            Message <span className="text-red-500">*</span>
          </Label>
          <Textarea
            value={supportMessage}
            onChange={(e) => setSupportMessage(e.target.value)}
            placeholder="Describe your issue or question in detail..."
            rows={6}
            className="dark:bg-[#1a1a1a] dark:text-white"
          />
        </div>

        <Button
          onClick={handleSendSupport}
          disabled={sendingSupport || !supportSubject.trim() || !supportMessage.trim()}
          className="w-full bg-[#FFD12D] hover:bg-[#252525] text-[#252525] hover:text-[#FFD12D] font-semibold py-4"
        >
          {sendingSupport ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Sending...
            </>
          ) : (
            <>
              <Send className="w-4 h-4 mr-2" />
              Send Message
            </>
          )}
        </Button>
      </div>

      <Separator className="bg-gray-200 dark:bg-gray-700" />

      <div className="bg-white dark:bg-[#1a1a1a] p-4 rounded-lg border border-gray-200 dark:border-gray-700">
        <h4 className="font-semibold text-[#252525] dark:text-white mb-2">Other Ways to Reach Us</h4>
        <div className="space-y-2 text-sm">
          <p className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
            <Mail className="w-4 h-4 text-[#FFD12D]" />
            <a href="mailto:hello@wayo.co.za" className="hover:text-[#FFD12D]">hello@wayo.co.za</a>
          </p>
          <p className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
            <Phone className="w-4 h-4 text-[#FFD12D]" />
            <a href="tel:+27748094378" className="hover:text-[#FFD12D]">+27-74-809-4378</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VendorSupportTab;
